import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, message } from 'antd';
import { ChallengeConfigProvider, defaultConfig, useChallengeConfig } from '../../contexts/BlocklyConfigContext';
import Blockly, { BlocklyRef } from '../Blockly';
import { TLesson } from '../../../../models/courses/lesson';
import { useUserApi } from '../../../../api/user/userApp';
import { useTilmiAuth } from '../../../../hooks/useTilmiAuth';
import { TUserAnswer } from '../../../../models/user/UserProgression';


// On reçoit eventManager en props
interface LessonBlocklyPhaserProps {
  lesson: TLesson | undefined;
  checkResult: (isValid: boolean) => void;
}

const LessonBlocklyPhaser: React.FC<LessonBlocklyPhaserProps> = ({ lesson, checkResult }) => {
  return (
    <ChallengeConfigProvider >
      <LessonBlocklyPhaserContent lesson={lesson} checkResult={checkResult} />
    </ChallengeConfigProvider>
  );
};

/**
 * Page d'administration permettant de configurer un challenge en temps réel.
 */
const LessonBlocklyPhaserContent: React.FC<LessonBlocklyPhaserProps> = ({ lesson, checkResult }) => {

  const { setConfig } = useChallengeConfig();
  const blocklyRef = useRef<BlocklyRef>(null);
  // État pour le Drawer 
  const [isWin, setIsWin] = useState(false);

  const { getUserAnswerById, saveUserAnswerById } = useUserApi();
  const { getUserAppId } = useTilmiAuth();
  const [answer, setAnswer] = useState<TUserAnswer | null>(null);
  useEffect(() => {
    if (!lesson) return;

    getUserAnswerById(lesson.id)
      .then((resp) => {

        setAnswer(resp.data);
        const baseConfig = lesson?.config?.config ?? defaultConfig();

        // On fait un setConfig(...) en fusionnant
        setConfig({
          ...baseConfig,
          // On force configWorkspace.adminMode = false
          configWorkspace: {
            ...baseConfig.configWorkspace,
            adminMode: false,
            workspace: resp.data?.workspace ?? baseConfig.configWorkspace.workspace,
          },
          configPhaser: {
            ...baseConfig.configPhaser,

          },
        });
      })
      .catch((err) => {
        message.error(err.response?.data ?? err.message ?? err ?? err)
      })


    // eslint-disable-next-line
  }, []);

  const onWin = () => {
    setIsWin(true);
  }

  useEffect(() => {
    if (isWin) {
      checkResult(true)
    }
    // eslint-disable-next-line
  }, [isWin])

  const onSave = (workspace: string) => {
    if (!lesson) return;
    const lessonAnswer: TUserAnswer = {
      id: answer?.id ?? 0,
      userapp_id: getUserAppId(),
      lesson_id: lesson.id,
      workspace: workspace,
    }
    saveUserAnswerById(lesson.id, lessonAnswer)
      .then((resp) => {

        setAnswer(resp.data);
      })
      .catch((err) => {
        message.error(err.response?.data ?? err.message ?? err ?? err)
      })
  }
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column', // Empile les éléments verticalement
      width: '100%',
      height: '100%'
    }}>

      {/* 1. L'énoncé de l'exercice */}
      <div style={{
        fontSize: '1.1em', // Police légèrement plus grande
        color: '#333', // Texte plus sombre
        fontWeight: '600',
        whiteSpace: 'pre-wrap'
      }}>
        {lesson?.statement}
      </div>

      {/* 2. L'espace de travail Blockly */}
      <div style={{ flex: 1 }}>
        <Blockly ref={blocklyRef} onWin={onWin} onSave={onSave} adminMode={false} />
      </div>

    </div>
  );
};

export default LessonBlocklyPhaser;
